export const PRIVACY_POLICY = `INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI
ai sensi del Regolamento UE 2016/679 (GDPR)
Ultimo aggiornamento: maggio 2026

1. TITOLARE DEL TRATTAMENTO

Paolo Murri — Roma (Italia)
Email: pmurri@gmail.com

Per qualsiasi richiesta relativa ai tuoi dati personali scrivi all'indirizzo sopra indicato.

───────────────────────────────────────

2. DATI RACCOLTI

Dati forniti in fase di registrazione:
• Nome e cognome
• Indirizzo email
• Città di residenza
• Strumenti suonati e voce
• Generi musicali preferiti
• Livello di competenza musicale
• Foto profilo (opzionale)

Dati generati dall'utilizzo dell'app:
• Partecipazione a eventi musicali
• Brani proposti e ruoli ricoperti
• Messaggi inviati nelle chat degli eventi
• Attrezzatura musicale inserita
• Foto e locandine degli eventi creati
• Preferenze e "like" ai brani (memorizzati localmente sul dispositivo)

Dati tecnici:
• Dati di sessione memorizzati nel browser (localStorage), per non doverti chiedere l'email a ogni apertura dell'app. Puoi cancellarli in qualsiasi momento uscendo dall'account o svuotando i dati del sito dal tuo browser. Non utilizziamo cookie di profilazione.

───────────────────────────────────────

3. FINALITÀ E BASE GIURIDICA

• Gestione dell'account — Consenso (Art. 6(1)(a) GDPR)
• Partecipazione a eventi — Consenso / Contratto (Art. 6(1)(a)(b))
• Visualizzazione profilo da altri utenti — Consenso (Art. 6(1)(a))
• Chat degli eventi — Consenso (Art. 6(1)(a))
• Miglioramento del servizio — Legittimo interesse (Art. 6(1)(f))
• Obblighi legali — Obbligo di legge (Art. 6(1)(c))

───────────────────────────────────────

4. CONSERVAZIONE DEI DATI

I dati sono conservati per tutta la durata dell'account attivo. Puoi eliminare il tuo account dalla sezione Profilo: tutti i tuoi dati saranno cancellati entro 30 giorni.

───────────────────────────────────────

5. DESTINATARI E TERZE PARTI

• Supabase Inc. — database e storage (server a Francoforte, Germania, UE). Conforme al GDPR.
• Vercel Inc. — hosting dell'applicazione web.

Non vendiamo né cediamo i tuoi dati a terzi per finalità di marketing.

───────────────────────────────────────

6. TRASFERIMENTO DATI EXTRA-UE

I dati del database sono conservati esclusivamente nell'UE (Francoforte). I trasferimenti extra-UE avvengono nel rispetto delle garanzie previste dal GDPR (Clausole Contrattuali Standard).

───────────────────────────────────────

7. I TUOI DIRITTI

Hai il diritto di:
• Accesso — ottenere copia dei tuoi dati (Art. 15)
• Rettifica — correggere dati inesatti (Art. 16)
• Cancellazione — richiedere l'eliminazione dei dati (Art. 17)
• Limitazione del trattamento (Art. 18)
• Portabilità dei dati (Art. 20)
• Opposizione al trattamento (Art. 21)
• Revoca del consenso in qualsiasi momento

Per esercitare questi diritti scrivi a pmurri@gmail.com. Risponderemo entro 30 giorni.

Puoi proporre reclamo al Garante per la Protezione dei Dati Personali (garanteprivacy.it).

───────────────────────────────────────

8. MINORI

In conformità al D.Lgs. 101/2018:
• Utenti dai 14 anni in su: possono registrarsi autonomamente.
• Utenti sotto i 14 anni: necessario il consenso di un genitore o tutore legale.

Se vieni a conoscenza di una registrazione di un minore di 14 anni senza consenso, segnalacelo a pmurri@gmail.com.

───────────────────────────────────────

9. MODIFICHE

Il Titolare si riserva il diritto di aggiornare questa informativa. In caso di modifiche sostanziali, gli utenti saranno informati tramite l'app.`;

export const TERMS_CONDITIONS = `TERMINI E CONDIZIONI D'USO
Applicazione Jammo
Ultimo aggiornamento: maggio 2026

1. OGGETTO E ACCETTAZIONE

I presenti Termini disciplinano l'utilizzo dell'applicazione web Jammo, messa a disposizione da Paolo Murri, Roma (Italia).

Utilizzando l'app e completando la registrazione dichiari di aver letto, compreso e accettato integralmente i presenti Termini.

───────────────────────────────────────

2. DESCRIZIONE DEL SERVIZIO

Jammo è un'applicazione per organizzare serate musicali (jam session). Permette di:
• Creare e partecipare a eventi musicali
• Proporre e organizzare scalette di brani
• Connettersi con altri musicisti
• Gestire la propria partecipazione a serate

Il servizio è attualmente in fase di test. Alcune funzionalità potrebbero essere modificate, sospese o rimosse senza preavviso durante questa fase.

───────────────────────────────────────

3. REGISTRAZIONE E ACCOUNT

• La registrazione richiede nome, email e alcune informazioni musicali. Sei responsabile della veridicità delle informazioni fornite.
• L'accesso avviene tramite email. Sei responsabile della riservatezza della tua sessione.
• È vietato creare account falsi, multipli per eludere limitazioni, o a nome di terzi senza autorizzazione.
• Puoi eliminare il tuo account in qualsiasi momento dalla sezione Profilo.

───────────────────────────────────────

4. UTILIZZO DELL'APP

Utilizzando Jammo ti impegni a:
• Non pubblicare contenuti offensivi, discriminatori, diffamatori o illegali
• Non utilizzare l'app per finalità commerciali non autorizzate
• Non interferire con il funzionamento tecnico dell'app
• Non tentare di accedere a dati o account di altri utenti
• Rispettare gli altri utenti e le norme di convivenza civile

───────────────────────────────────────

5. CONTENUTI PUBBLICATI

• Sei il solo responsabile dei contenuti che pubblichi (testi, foto, messaggi, eventi).
• Pubblicando contenuti concedi a Paolo Murri una licenza non esclusiva e gratuita per mostrarli agli altri utenti nell'ambito del servizio.
• È vietato pubblicare contenuti che violino diritti di terzi (diritti d'autore, marchi, privacy).

───────────────────────────────────────

6. SERVIZIO GRATUITO E FUTURO A PAGAMENTO

• L'app è attualmente gratuita nella fase di test.
• In futuro potranno essere introdotte funzionalità a pagamento. Gli utenti saranno informati con preavviso e potranno scegliere liberamente.
• Nessun addebito sarà effettuato senza esplicito consenso dell'utente.

───────────────────────────────────────

7. MINORI

• Gli utenti sotto i 14 anni possono utilizzare l'app solo con il consenso esplicito di un genitore o tutore legale.
• I genitori che concedono il consenso si assumono la responsabilità del comportamento del minore nell'app.

───────────────────────────────────────

8. LIMITAZIONE DI RESPONSABILITÀ

• Jammo è un servizio di coordinamento tra musicisti. Il Titolare non è responsabile per quanto accade negli eventi fisici.
• Il Titolare non garantisce la disponibilità continua del servizio, in particolare durante la fase di test.
• Il Titolare non è responsabile per comportamenti scorretti di altri utenti. Segnalazioni: pmurri@gmail.com.

───────────────────────────────────────

9. SOSPENSIONE E CANCELLAZIONE

Il Titolare si riserva il diritto di sospendere o cancellare account che violino i presenti Termini, con o senza preavviso, in caso di comportamenti abusivi o lesivi verso altri utenti.

───────────────────────────────────────

10. MODIFICHE AI TERMINI

Il Titolare si riserva il diritto di modificare i presenti Termini. Le modifiche saranno comunicate tramite l'app. L'utilizzo continuato costituisce accettazione dei nuovi Termini.

───────────────────────────────────────

11. LEGGE APPLICABILE E FORO COMPETENTE

I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Roma, salvo diversa disposizione inderogabile a tutela del consumatore.`;
